import React from 'react';
import { Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <img 
            src="https://customer-assets.emergentagent.com/job_gored-merch-drop/artifacts/2v69vx4n_rendered%20red%20GORED.png" 
            alt="GORED Logo" 
            className="footer-logo"
          />
          <p className="footer-tagline">Black Death Metal</p>
        </div>

        <div className="footer-section">
          <h4 className="footer-title">Links</h4>
          <ul className="footer-links">
            <li><a href="#shop">Shop</a></li>
            <li><a href="#preorder">Pre-Order</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4 className="footer-title">Follow Us</h4>
          <div className="social-links">
            <a href="https://www.instagram.com/gored.band?igsh=MXQ1dXhxdzhpcmk0dg==" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 GORED. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
